<template>
  <el-dialog
    ref="myPublishDialog"
    :visible.sync="config.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="!isDesktop"
    :show-close="false"
    :top="marginTop"
    custom-class="pop_page myPublishDialog"
  >
    <span slot="title">
      <span class="el-dialog__title size16">{{ publishTitle || title }}</span>
      <i class="iconfont my-close title-btn size20" :title="$t('i.close')" @click="close" />
    </span>
    <div v-loading="loading" shadow="never" class="padding-top8" :element-loading-text="$t('i.submitting')" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-form label-width="82px" style="width: 100%;margin: 0 auto;">
        <el-col v-if="uploadMod" :span="24">
          <el-form-item v-if="uploadType === 'views'" class="my-el-form-item" style="height: 80px;">
            <div v-if="files.image" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
              <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-33)'}">
                <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.image.url" />
              </div>
              <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('image')" /></div>
            </div>
            <div v-if="!files['image']" class="padding4 float-left">
              <div class="round4 padding-top10 bg-33 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('image')"><div :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</div><div class="size12">{{ $t('i.uploadFrontImg') }}</div></div>
            </div>
            <div v-if="files.left_image" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
              <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-33)'}">
                <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.left_image.url" />
              </div>
              <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('left_image')" /></div>
            </div>
            <div v-if="!files['left_image']" class="padding4 float-left">
              <div class="round4 padding-top10 bg-33 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('left_image')"><div :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</div><div class="size12">{{ $t('i.uploadLeftImg') }}</div></div>
            </div>
            <div v-if="files.right_image" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
              <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-33)'}">
                <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.right_image.url" />
              </div>
              <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('right_image')" /></div>
            </div>
            <div v-if="!files['right_image']" class="padding4 float-left">
              <div class="round4 padding-top10 bg-33 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('right_image')"><div :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</div><div class="size12">{{ $t('i.uploadRightImg') }}</div></div>
            </div>
            <div v-if="files.back_image" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
              <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-33)'}">
                <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.back_image.url" />
              </div>
              <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('back_image')" /></div>
            </div>
            <div v-if="!files['back_image']" class="padding4 float-left">
              <div class="round4 padding-top10 bg-33 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('back_image')"><div :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</div><div class="size12">{{ $t('i.uploadBackImg') }}</div></div>
            </div>
          </el-form-item>
          <el-form-item v-if="uploadType === 'img'" class="my-el-form-item" style="height: 80px;">
            <div v-if="files[uploadType]" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
              <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-33)'}">
                <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files[uploadType].url" />
              </div>
              <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile(uploadType)" /></div>
            </div>
            <div v-if="!files[uploadType]" class="padding4 float-left">
              <div class="round4 padding-top10 bg-33 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles(uploadType)"><div :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</div><div class="size12">{{ uploadType === 'img' ? $t('i.uploadPixel') : uploadType === 'model' ? $t('i.uploadModel') : $t('i.uploadVox') }}</div></div>
            </div>
          </el-form-item>
          <el-form-item v-if="uploadType !== 'img' && uploadType !== 'views'" class="my-el-form-item" style="height: 80px;">
            <div v-if="files[uploadType] && !files[uploadType + '_image']" class="round4 align-center padding-top8" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-33)'}">
              <i :class="'iconfont color-cc ' + (uploadType === 'model' ? 'my-d3s' : 'my-vox')" style="font-size: 36px;" />
            </div>
            <div v-if="files[uploadType] && !files[uploadType + '_image']" class="align-center bg-11" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile(uploadType)" /></div>
            <div v-if="files[uploadType] && files[uploadType + '_image']" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
              <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-33)'}">
                <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files[uploadType + '_image']" />
              </div>
              <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile(uploadType)" /></div>
            </div>
            <div v-if="!files[uploadType]" class="padding4 float-left">
              <div class="round4 padding-top10 bg-33 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles(uploadType)"><div :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</div><div class="size12">{{ uploadType === 'img' ? $t('i.uploadPixel') : uploadType === 'model' ? $t('i.uploadModel') : $t('i.uploadVox') }}</div></div>
            </div>
          </el-form-item>
          <img
            v-show="false"
            id="image"
            ref="image"
            :src="blankImage"
          >
          <voxel-viewer
            v-show="false"
            ref="voxViewer"
            :state="state"
            :width="512"
            :height="512"
            :sky-styleid="0"
            :fixpos="-1"
            @receive="(event) => emit('handle', event)"
          />
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('i.catalogue')" class="my-el-form-item">
            <el-select v-model="file.catalogid" style="width: 220px;" :placeholder="$t('i.pleaseSelect')" @change="changeCatalog">
              <el-option
                v-for="item in catalogs"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="23">
          <el-form-item :label="$t('i.title')">
            <el-input v-model="file.name" style="width: 100%;" class="my-from-item" name="name" :placeholder="$t('i.inputTitle')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="23">
          <el-form-item :label="$t('i.introduction')">
            <el-input v-model="file.info" type="textarea" class="my-from-item" name="info" :autosize="{ minRows: inputRows, maxRows:inputRows }" :rows="inputRows" style="width: 100%;" :maxlength="1000" :placeholder="$t('i.inputIntro')" />
          </el-form-item>
        </el-col>
        <el-col :span="23">
          <el-form-item :label="$t('i.tag')" class="my-el-form-item">
            <tags :tags="file.tags" />
          </el-form-item>
        </el-col>
        <el-col :span="23">
          <el-form-item :label="$t('i.showOut')" class="my-el-form-item">
            <el-checkbox v-model="tmp.show">{{ $t('i.pubShow') }}</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="23">
          <el-form-item :label="$t('i.share')" class="my-el-form-item">
            <el-checkbox v-model="tmp.share">{{ $t('i.shareOut') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <span slot="footer" class="footer" style="position:absolute;">
      <input ref="publish-uploader" :multiple="false" type="file" :accept="acceptExtends" style="display:none;" @change="selectFiles">
      <el-button class="margin-bottom12 btn-ok" type="light" style="width:200px;" @click="() => publishWork()">{{ $t('i.ok') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mixins } from '@/mixins/common'
import voxelViewer from '@/components/viewer/voxelViewer'
import md5 from 'js-md5'
import GRIDY from '@/js/sdk/GridySDK'
import COSSDK from '@/js/sdk/cosSDK'
import utils from '@/js/utils'
import conf from '@/js/conf/conf'
import tags from '@/components/tags'
import service from '@/js/service'
import blankImage from '@/assets/blank.png'
export default {
  components: {
    voxelViewer,
    tags
  },
  mixins: [mixins],
  props: {
    db: {
      type: Object,
      default() {
        return {}
      }
    },
    tmp: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    const data = {
      loading: false,
      reqing: false,
      fileType: '',
      thumbSize: 75,
      files: {
        img: '',
        views: '',
        views_image: '',
        vox: '',
        vox_image: '',
        chain_brick: '',
        chain_brick_image: '',
        lego_brick: '',
        lego_brick_image: '',
        model: '',
        model_image: '',
        image: '',
        left_image: '',
        right_image: '',
        back_image: ''
      },
      GRIDY: new GRIDY(),
      inited: false,
      blankImage: blankImage,
      imgEl: null,
      voxelViewerEl: null
    }
    data.COSSDK = null
    data.apiHost = conf.hosts().apiHost
    data.worksHost = conf.hosts().worksHost
    data.catalogs = conf.catalogs()
    this.file.catalogid = this.file.catalogid || this.tmp.catalogid
    if (!this.file.tags || !utils.isArray(this.file.tags) || !this.file.tags.length) {
      this.file.tags = this.tmp.tags
    }
    // 图片单边分辨率要求不小于128，不大于5000。大小不超过8m
    data.maxImageWidth = 1024 * 2
    data.maxImageHeight = 1024 * 2
    return data
  },
  computed: {
    config() {
      return this.view.myPublish
    },
    uploadType() {
      return (this.config.data && this.config.data.type) ? this.config.data.type : ''
    },
    title() {
      return (this.tmp.file.workid || this.file.workid) ? this.$t('i.editWork') : this.$t('i.pubWork')
    },
    uploadMod() {
      return this.uploadType === 'img' || this.uploadType === 'views' || this.uploadType === 'model' || this.uploadType === 'vox' || this.uploadType === 'chain_brick' || this.uploadType === 'lego_brick'
    },
    publishTitle() {
      const titles = {
        img: this.$t('i.pixel'),
        views: this.$t('i.ip_imgs'),
        model: this.$t('i.type_d3s'),
        vox: this.$t('i.type_vox'),
        chain_brick: this.$t('i.chain_block'),
        lego_brick: this.$t('i.lego_block')
      }
      return titles[this.uploadType] ? (this.$t('i.publish') + ' ' + titles[this.uploadType]) : ''
    },
    inputRows() {
      return this.uploadMod ? 7 : 12
    },
    maxFilesize() {
      if (this.loginUserId < 10000) {
        return 1024 * 1024 * 128
      }
      return 1024 * 1024 * 64
    },
    acceptExtends() {
      if (this.uploadType === 'model') {
        // 支持： .glb,.obj,.stl
        return '.glb,.obj,.stl'
      } else if (this.uploadType === 'vox' || this.uploadType === 'chain_brick' || this.uploadType === 'lego_brick') {
        return '.vox'
      } else {
        // 支持： jpg，png，jpeg，webp
        return '.jpg,.jpeg,.png,.webp'
      }
    },
    currentWorkClass() {
      return this.worksClass.find(workClass => workClass.classid === this.config.classid)
    },
    worksClass() {
      const worksClass = conf.workClasses()
      worksClass.forEach(workClass => {
        workClass.checked = workClass.classid === this.config.classid
      })
      return worksClass
    }
  },
  mounted() {
    if (this.config.show && this.uploadMod) {
      this.init()
    }
  },
  methods: {
    init(cb) {
      if (this.inited) {
        cb && cb()
        return
      }
      this.imgEl = this.$refs.image
      this.voxelViewerEl = this.$refs.voxViewer
      if (!this.imgEl || !this.voxelViewerEl) {
        setTimeout(() => {
          this.init(cb)
        }, 10)
        return
      }
      this.imgEl.onload = this.load
      this.imgEl.onerror = this.load
      this.inited = true
      cb && cb()
    },
    rendVoxel(file, cb) {
      file = file || this.file
      if (file.type === 2) return
      this.voxelViewerEl.setWork(file)
      // 类型；0=百格画; 1=拼图; 2=图片; 3=3D模型; 4=体素模型; 5=串联积木模型; 6=乐高积木模型; 7=IP形象; 9=其他;
      if (file.type === 3) {
        this.voxelViewerEl.setDiyMod('d3')
      } else if (file.type === 4) {
        this.voxelViewerEl.setDiyMod('vox')
      } else if (file.type === 5) {
        this.voxelViewerEl.setDiyMod('chain_brick')
      } else if (file.type === 6) {
        this.voxelViewerEl.setDiyMod('lego_brick')
      } else {
        this.voxelViewerEl.setDiyMod('')
      }
      this.voxelViewerEl.launch(() => {
        this.voxelViewerEl.draw(this.imgEl, cb)
      })
    },
    changeCatalog(catalogid) {
      this.file.catalogid = catalogid
      this.tmp.file.catalogid = catalogid
    },
    delFile(fileType) {
      this.files[fileType] = ''
      if (this.files[fileType + '_image']) this.files[fileType + '_image'] = ''
      this.file.name = ''
      this.voxelViewerEl.resetVoxelChunks()
    },
    openFiles(fileType) {
      this.fileType = fileType
      setTimeout(() => {
        this.$refs['publish-uploader'].click()
      }, 100)
    },
    setUploadPath(fileType, fileName) {
      if (this.file.data) {
        let path = ''
        if (fileType === 'img' || fileType === 'image' || fileType === 'left_image' || fileType === 'right_image' || fileType === 'back_image') {
          path = 'cos://' + fileType + '/' + utils.calcUserPath(this.loginUserId) + '/' + fileName
        } else {
          path = 'cos://' + fileType + '/' + utils.calcUserPath(this.loginUserId) + '/' + md5(fileName + '_' + utils.time('time')) + '.' + fileName.split('.').pop()
        }
        if (fileType === 'image') {
          this.file.data.url = path
          this.file.data.image_url = path
        } else if (fileType === 'left_image' || fileType === 'right_image' || fileType === 'back_image') {
          this.file.data[fileType] = path
        } else {
          this.file.data.url = path
          this.file.data.image_url = utils.changeExtension(path, 'png')
        }
      }
    },
    previewFile(file) {
      if (this.file && this.file.data && this.file.type > 2 && this.file.type <= 6) {
        this.file.fileObj = file
        this.rendVoxel(this.file, () => {
          this.file.voxelBlob = this.voxelViewerEl.getVOXFileBlob()
          const snapshot = this.voxelViewerEl.getSnapshot()
          this.file.snapshot = snapshot[0]
          this.file.width = snapshot[1]
          this.file.height = snapshot[2]
          this.files[this.fileType + '_image'] = snapshot[0]
        })
      }
    },
    selectFiles() {
      if (!this.loginStatus) {
        this.$refs['publish-uploader'].value = ''
        this.emit('login')
        return
      }
      const dom = this.$refs['publish-uploader']
      const localFiles = dom.files
      if (!localFiles.length) {
        return
      }
      const denyFiles = []
      Object.values(localFiles).map((file) => {
        if (this.fileType === 'img' || this.fileType.indexOf('image') !== -1) {
          this.GRIDY.compressImage(file.name, window.URL.createObjectURL(file), (fileObj) => {
            file.width = fileObj.width
            file.height = fileObj.height
            file.ext = fileObj.ext
            file.mime = fileObj.mime
            file.quality = fileObj.quality
            file.md5 = md5(fileObj.base64)
            file.url = fileObj.base64
            this.files[this.fileType] = file
            this.file.name = file.name
            if (['img', 'image'].indexOf(this.fileType) !== -1) {
              this.file.width = fileObj.width
              this.file.height = fileObj.height
            }
            this.setUploadPath(this.fileType, fileObj.md5 + '.' + fileObj.ext)
            this.previewFile(file)
            this.$refs['publish-uploader'].value = ''
          }, this.maxImageWidth, this.maxImageHeight, 'file')
        } else {
          if (file.size > this.maxFilesize) {
            denyFiles.push(file.name)
          } else {
            this.files[this.fileType] = file
            this.file.name = file.name
            this.setUploadPath(this.fileType, file.name)
            this.previewFile(file)
          }
          this.$refs['publish-uploader'].value = ''
        }
      })
      if (denyFiles.length) {
        this.alert(denyFiles.join('、') + ' ' + this.$t('i.maxFilesize', { count: utils.formateBytes(this.maxFilesize) }))
      }
    },
    // 上传文件
    uploadFile(key, file, cb) {
      this.COSSDK = new COSSDK()
      this.COSSDK.putObject({
        Bucket: conf.cosBucket.bucket,
        Region: conf.cosBucket.region,
        Key: key,
        Body: file
      }, (err, data) => {
        if (!err && data && data.statusCode === 200 && data.Location) {
          cb && cb(true)
        } else {
          this.message(this.$t('i.busy'), 'error')
          cb && cb(false)
        }
      })
    },
    // 上传到COS
    uploadToCos(cos_url, file, ref_url, cb) {
      let key = ''
      if (cos_url) {
        key = cos_url
      } else {
        key = utils.changeExtension(ref_url, 'png')
      }
      if (key) {
        this.uploadFile(key.replace('cos://', '/public/paint/'), file, (success) => {
          if (success) {
            cb && cb(key)
          } else {
            cb && cb()
          }
        })
      }
    },
    close() {
      this.view.myPublish.show = false
      this.view.myPublish.data = {}
      this.view.myPublish.fn = null
    },
    publishWork() {
      this.emit('loading', [true])
      const saveRemote = () => {
        const data = utils.deepClone(this.file)
        delete data.snapshot
        delete data.voxelBlob
        delete data.voxelChunks
        delete data.opts
        data.data = JSON.stringify(data.data)
        this.emit('saveRemote', [data, false, this.tmp.share, (file) => {
          this.emit('loading', [false])
          if (file) {
            this.view.myPublish.show = false
            this.view.myPublish.data = {}
            this.view.myPublish.fn && this.view.myPublish.fn(file)
          }
        }])
      }
      this.file.public = this.tmp.show ? 1 : 0
      this.file.publish = true
      this.file.publishTime = utils.date('datetime')
      this.tmp.catalogid = this.file.catalogid
      this.tmp.tags = this.file.tags
      if (this.file.type >= 2 && this.file.data) {
        if (this.file.data.url) this.file.data.url = service.encodeCosUrl(this.file.data.url, 'paint')
        if (this.file.data.image_url) this.file.data.image_url = service.encodeCosUrl(this.file.data.image_url, 'paint')
        if (this.file.data.type === 'views') {
          let count = 0
          const uploadCb = () => {
            count--
            if (count === 0) {
              saveRemote()
            }
          }
          if (this.files.image) {
            this.uploadToCos(this.file.data.url, this.files.image, this.file.data.url, (key) => {
              if (key) {
                this.file.data.url = key
                this.file.data.image_url = key
              }
              uploadCb()
            })
            count++
          }
          if (this.files.left_image) {
            this.uploadToCos(this.file.data.left_image, this.files.left_image, this.file.data.left_image, (key) => {
              if (key) {
                this.file.data.left_image = key
              }
              uploadCb()
            })
            count++
          }
          if (this.files.right_image) {
            this.uploadToCos(this.file.data.right_image, this.files.right_image, this.file.data.right_image, (key) => {
              if (key) {
                this.file.data.right_image = key
              }
              uploadCb()
            })
            count++
          }
          if (this.files.back_image) {
            this.uploadToCos(this.file.data.back_image, this.files.back_image, this.file.data.back_image, (key) => {
              if (key) {
                this.file.data.back_image = key
              }
              uploadCb()
            })
            count++
          }
        } else if (this.file.data.type === 'd3') {
          const imageBlob = utils.base64ToBlob(this.file.snapshot)
          this.uploadToCos(this.file.data.image_url, imageBlob, this.file.data.url, (key) => {
            if (key) {
              this.file.data.image_url = key
            }
            if (this.uploadMod) {
              // 上传3d文件
              this.uploadToCos(this.file.data.url, this.file.fileObj, this.file.data.image_url, (key) => {
                if (key) {
                  this.file.data.url = key
                }
                saveRemote()
              })
            } else {
              saveRemote()
            }
          })
        } else if (this.file.data.type === 'vox' || this.file.data.type === 'chain_brick' || this.file.data.type === 'lego_brick') {
          // 上传截图
          const imageBlob = utils.base64ToBlob(this.file.snapshot)
          this.uploadToCos(this.file.data.image_url, imageBlob, this.file.data.url, (key) => {
            if (key) {
              this.file.data.image_url = key
            }
            // 上传体素文件
            this.uploadToCos(this.file.data.url, this.uploadMod ? this.file.fileObj : this.file.voxelBlob, this.file.data.image_url, (key) => {
              if (key) {
                this.file.data.url = key
              }
              saveRemote()
            })
          })
        } else {
          if (this.uploadMod && this.fileType === 'img') {
            this.uploadToCos(this.file.data.url, this.files[this.fileType], this.file.data.url, (key) => {
              if (key) {
                this.file.data.url = key
                this.file.data.image_url = key
              }
              saveRemote()
            })
          } else {
            saveRemote()
          }
        }
      } else {
        saveRemote()
      }
    }
  }
}
</script>
